export default {"src":"/_next/static/media/profile.f73ba5bc.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};